module.exports = __webpack_public_path__ + "img/logo.1a5aeda5.svg";